import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { mdiCalendarCheckOutline, mdiClockOutline } from '@mdi/js'

import { getDateFormattedForPicker, getTimeFormatted } from '@/services/date'
import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import { useEventUpdateMutation } from '@/enitites/event/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventDate',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const { error, isPending, mutate: updateEvent } = useEventUpdateMutation()





const menuDateStart = ref(false)
const menuDateEnd = ref(false)
const dateStart = ref(getDateFormattedForPicker(props.eventData.dateStart) || '')
const dateEnd = ref(getDateFormattedForPicker(props.eventData.dateEnd) || '')
const timeStart = ref(getTimeFormatted(props.eventData.dateStart) || '12:00')
const timeEnd = ref(getTimeFormatted(props.eventData.dateEnd) || '12:00')

const errorMessage = ref<string>()

function createDateTime(date: string, time: string) {
  return new Date(`${date.replace(/-/g, '/')} ${time}`)
}

const isInvalidDate = computed(() => {
  return (
    createDateTime(dateEnd.value, timeEnd.value).getTime() < createDateTime(dateStart.value, timeStart.value).getTime()
  )
})

const isDateFilledOut = computed(() => !!dateStart.value && !!dateEnd.value && !!timeStart.value && !!timeEnd.value)

function saveEventData(onSuccess: () => void) {
  if (!isDateFilledOut.value || isPending.value) return
  errorMessage.value = undefined

  if (isInvalidDate.value) {
    errorMessage.value = "End Date can't be before the Start Date"
    return
  }

  const dateStartObj = createDateTime(dateStart.value, timeStart.value)
  const dateEndObj = createDateTime(dateEnd.value, timeEnd.value)

  const isSameDay = dateStartObj.getDate() === dateEndObj.getDate()
  const dateOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' }
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' }

  // Apr 5, 2023 - Apr 8, 2023
  const dateFlat = isSameDay
    ? dateStartObj.toLocaleDateString('en-US', dateOptions)
    : `${dateStartObj.toLocaleDateString('en-US', dateOptions)} - ${dateEndObj.toLocaleDateString('en-US', dateOptions)}`

  // 10:00 AM - 5:00 PM
  const timeFlat = `${dateStartObj.toLocaleTimeString('en-US', timeOptions)} - ${dateEndObj.toLocaleTimeString('en-US', timeOptions)}`

  const payload = {
    ...props.eventData,
    dateFlat,
    timeFlat,
    dateStart: dateStartObj.toISOString(),
    dateEnd: dateEndObj.toISOString(),
  }

  updateEvent(payload, { onSuccess })
}

function handleNext() {
  saveEventData(() => {
    emit('next')
  })
}

function handleCancel() {
  saveEventData(() => {
    emit('cancel')
  })
}

return { __sfc: true,error, isPending, updateEvent, props, emit, menuDateStart, menuDateEnd, dateStart, dateEnd, timeStart, timeEnd, errorMessage, createDateTime, isInvalidDate, isDateFilledOut, saveEventData, handleNext, handleCancel, mdiCalendarCheckOutline, mdiClockOutline, EventEditActionButtons }
}

})